import actions from './actions';

const initialState = () => ({
  reviewId: null,
  greetReviewId: null,
});

export default {
  state: initialState,
  mutations: {
    SET_REVIEW_ID(state, reviewId) {
      state.reviewId = reviewId;
    },
    SET_GREET_REVIEW_ID(state, greetReviewId) {
      state.greetReviewId = greetReviewId;
    },
  },
  actions,
  getters: {
    reviewId: state => state.reviewId,
    greetReviewId: state => state.greetReviewId,
  },
};
